import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-people-profile',
	templateUrl: './people-profile.component.html',
	styleUrls: ['./people-profile.component.scss'],
})
export class PeopleProfileComponent implements OnInit {
	roles: string[];
	constructor() {
		// comment
	}

	ngOnInit() {
		this.roles = ['course creator', 'Instructor'];
	}
}
